import React, { Component, Fragment } from 'react';
import {
    LoadingComponent, PageListComponent, HeaderListComponent,
} from "../../../../common/component/Index";
import DEFINE, { PATHS } from "../../../../../../constants/Define";
import { isEqual, get } from 'lodash';
import * as Func from '../../../../../../helpers/functions';
import SaleReport from '../../../../../../models/SaleReport';

import Wrapper from './../../../../common/component/Wrapper';

import { omit } from 'lodash';
import ReportSummary from './ReportSummary';
import ReportList from './ReportList';

import './SaleReportsByOrder.less';

let permisionActions = [];
const defaultState = {

};

export default class SaleReportsByOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            filters: {},
        };
    }

    componentDidMount() {
        this.getSaleReportsByOrder()
    }

    render() {
        const { t, hideHeader, reportState, orderState } = this.props;
        const { isFetching, saleReportByOrder } = reportState;
        return (
            <PageListComponent className="page-sale-report">
                {!hideHeader &&
                    <HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'orders'}
                        titleHeader={t('item.order.saleReportByOrder')}

                    />
                }
                <Wrapper className="">
                    <ReportSummary report={saleReportByOrder} loading={isFetching} />
                    <ReportList report={saleReportByOrder}
                        loading={isFetching}
                        downloading={orderState.isFetchingDownload}
                        onChangeFilters={this.getSaleReportsByOrder}
                        onExportExcel={this.onExportExcel}
                        />
                </Wrapper>
            </PageListComponent>
        );
    }

    getSaleReportsByOrder = (filters) => {
        const { reportState: { saleReportByOrder } } = this.props;
        if (!filters) filters = omit(saleReportByOrder.saleReportByOrderItems, ['items']);
        filters = omit(filters, ['totalCount', 'totalPage'])
        this.setState({ filters });
        this.props.getSaleReportByOrder(filters);
    }

    onExportExcel = (filters) => {
        this.props.exportExcel(filters);
    }

}

SaleReportsByOrder.defaultProps = {
    hideHeader: false,
}
